import { GetPredictiveDriveTimeReportAsCsvInput, GetPredictiveDriveTimeReportAsCsvResponse } from '@/models/gen/graphql';

import { Dayts } from '@/utils/Dayts';
import { GetPredictiveDriveTimeReportAsCsvDocument } from '@/api/queries';
import { GraphApiResponse } from '@/api/core';
import graphApi from '@/api';
import { handleError } from '@/utils/custom';
import { saveFile } from '@/utils/promises';

export type GetPredictiveDriveTimeReportAsCsvGraphApiResponse = GraphApiResponse<typeof GetPredictiveDriveTimeReportAsCsvDocument>;

export const getPredictiveDriveTimeReportAsCsvResponseSelector = (
  res: GetPredictiveDriveTimeReportAsCsvGraphApiResponse
): GetPredictiveDriveTimeReportAsCsvResponse['output'] => res?.getPredictiveDriveTimeReportAsCSV?.output;

export const [runGetPredictiveDriveTimeReportAsCsv, runRefetchGetPredictiveDriveTimeReportAsCsv] = graphApi(
  GetPredictiveDriveTimeReportAsCsvDocument
);

const getPredictiveDriveTimeReportAsCsv = async (
  input: GetPredictiveDriveTimeReportAsCsvInput
): Promise<GetPredictiveDriveTimeReportAsCsvResponse['output']> => {
  if (!input.queryHistoryId && !input.manifestHistoryRouteId) throw new Error('Failed to export report as csv: route id must be provided.');
  const res = await runRefetchGetPredictiveDriveTimeReportAsCsv({ input });
  return getPredictiveDriveTimeReportAsCsvResponseSelector(res);
};

export const exportPredictiveDriveTimeReportToCsv = async (
  routeId: string,
  key: 'queryHistoryId' | 'manifestHistoryRouteId',
  timeFrameId?: string
): Promise<void> => {
  try {
    const output = await getPredictiveDriveTimeReportAsCsv({
      [key || 'queryHistoryId']: routeId,
      timeFrameId,
    });
    if (!output) return;
    const blob = new Blob([output], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    saveFile(url, `DriveTime Report ${new Dayts().formatAs(Dayts.Format.DATE_INPUT)}.csv`);
  } catch (err) {
    handleError(err, { notification: { title: 'Drive Time Report' } });
  }
};

export default getPredictiveDriveTimeReportAsCsv;
